/* eslint-disable @typescript-eslint/no-explicit-any */
import { useHeaderContext } from '@/sinister/header/contexts/HeaderContext'
import Icon from '@mercadoni/sinister/dist/cjs/Icon'
import { UseLoggedContext } from '@mercadoni/sinister/dist/cjs/authentication/contexts'
import { FC } from 'react'
import styled from 'styled-components'
import MainText from './MainText'
import SecondaryText from './SecondaryText'

const StyledButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 12px;
  gap: 8px;
  border-radius: 16px;
  border: none;
  cursor: pointer;
  max-width: 200px;
  color: var(--app-header-color-desktop-v3, var(--color-white));
  ${({ isLightBackground }: { isLightBackground: boolean }) =>
    isLightBackground
      ? `background-color: #f2f2f2;`
      : `background-color: #00000024;`}

  .account-menu {
    &__content {
      display: flex;
      flex-flow: column;
      justify-content: flex-start;
      text-align: left;
      overflow: hidden;
      color: transparent;
    }
    &__icon {
      display: flex;
      align-items: center;
      justify-content: center;
      ${({ isLightBackground }: { isLightBackground: boolean }) =>
        isLightBackground
          ? `background-color: #c9c9c9;`
          : `background-color: #0000002e;`}
      border-radius: 50%;
      height: 44px;
      width: 44px;
      flex-shrink: 0;
    }
  }
`

interface ButtonDecoratorProps {
  onClick?: () => void
  className?: string
}

interface ButtonLogicProps extends ButtonDecoratorProps {
  Wrapper: FC<any>
}

const ButtonLogic: FC<ButtonLogicProps> = ({ Wrapper, onClick, className }) => {
  const { isLogged } = UseLoggedContext()
  const { customer, copies, isLightBackground, site } = useHeaderContext()
  const customerName = customer && customer?.name
  const { clients } = copies
  const { user } = clients?.generalheader || {}

  return (
    <Wrapper
      className={`${className} account-menu`}
      onClick={onClick}
      isLightBackground={isLightBackground || false}
    >
      <div className="account-menu__icon">
        <Icon size={24} className="ph-user" aria-label="Account" />
      </div>
      <div className="account-menu__content">
        <MainText>
          {`${user?.hi} ${isLogged ? customerName : user?.login}`}
        </MainText>
        {site !== 'sales' && <SecondaryText>{user?.account}</SecondaryText>}
      </div>
    </Wrapper>
  )
}

const Button: FC<ButtonDecoratorProps> = (props: ButtonDecoratorProps) => (
  <ButtonLogic Wrapper={StyledButton} {...props} />
)

export default Button
